export const SITE_NAME = "Starstruck Nails & Spa";
export const SITE_CITY = "Tucson";
export const SITE_REGION = "AZ";
export const SITE_POSTAL = "85704";
export const SITE_STREET = "2040 W Orange Grove Rd #122";
export const SITE_ADDRESS = `${SITE_STREET}, ${SITE_CITY}, ${SITE_REGION} ${SITE_POSTAL}`;
export const SITE_PHONE = "(520) 250-4136";
export const SITE_TEL = "+15202504136";
export const SITE_EMAIL = "Starstrucknailspa@gmail.com";
export const SITE_LOGO = "/industries/starstruck-logo.jpg";
export const SITE_MARK = "/industries/starstruck-mark.jpg";
export const CANONICAL_ORIGIN = "https://starstrucknailsandspa.com";

const PRODUCTION_HOSTS = new Set(["starstrucknailsandspa.com", "www.starstrucknailsandspa.com"]);

export function publicOrigin() {
  if (typeof window === "undefined") return "";
  const host = window.location.hostname.toLowerCase();
  if (PRODUCTION_HOSTS.has(host)) return CANONICAL_ORIGIN;
  return window.location.origin;
}

export const SEO_TITLE = `${SITE_NAME} | Tucson Nail Salon on West Orange Grove`;
export const SEO_DESCRIPTION =
  "Starstruck Nails & Spa is a boutique nail salon at 2040 W Orange Grove Rd #122, Tucson, AZ 85704. Gel manicures, spa pedicures, acrylics, Gel-X, dip, waxing, kids services, and private parties for Northwest Tucson and Oro Valley. Call (520) 250-4136.";

export const PAGE_SEO = {
  home: {
    title: SEO_TITLE,
    description: SEO_DESCRIPTION,
  },
  services: {
    title: `${SITE_NAME} Salon Menu | Pedicure, Gel, Acrylic & Waxing in Tucson`,
    description:
      "Salon menu at Starstruck Nails & Spa in Tucson, AZ: spa and deluxe pedicures, gel and deluxe manicures, acrylic and Gel-X, dip powder, silk wax, kids nails, and add-ons on West Orange Grove Road.",
  },
  reserve: {
    title: `Reserve Your Visit | ${SITE_NAME} in Tucson, AZ`,
    description:
      "Reserve a chair at Starstruck Nails & Spa in Tucson. Book a time on our schedule, or call (520) 250-4136. West Orange Grove Road, 85704.",
  },
  faq: {
    title: `FAQ | ${SITE_NAME} in Tucson, AZ`,
    description:
      "Answers about Starstruck Nails & Spa in Tucson: location, hours, gel and acrylic, Gel-X, dip, kids nails, silk wax, and how to book on West Orange Grove Road.",
  },
  gallery: {
    title: `Nail Art Gallery | ${SITE_NAME} in Tucson, AZ`,
    description:
      "French manicures, nudes, color, and nail art at Starstruck Nails & Spa, 2040 W Orange Grove Rd #122, Tucson, AZ 85704.",
    image: "/gallery/french.jpg",
    imageAlt: "Black and white French nails at Starstruck Nails & Spa in Tucson, AZ",
  },
  contact: {
    title: `Request a Quote | ${SITE_NAME} in Tucson, AZ`,
    description:
      "Request a quote for bridal parties, birthdays, showers, and work events at Starstruck Nails & Spa, 2040 W Orange Grove Rd #122, Tucson. Call (520) 250-4136.",
  },
};

export function seoForPage(page = "home") {
  return PAGE_SEO[page] || PAGE_SEO.home;
}

function pageSeoForPath(path) {
  if (path.startsWith("/services")) return PAGE_SEO.services;
  if (path.startsWith("/reserve")) return PAGE_SEO.reserve;
  if (path.startsWith("/faq")) return PAGE_SEO.faq;
  if (path.startsWith("/gallery")) return PAGE_SEO.gallery;
  if (path.startsWith("/contact")) return PAGE_SEO.contact;
  return PAGE_SEO.home;
}

const PAGE_CRUMBS = [
  ["/services", "Salon Menu"],
  ["/gallery", "Nail Art Gallery"],
  ["/reserve", "Reserve"],
  ["/contact", "Request a Quote"],
  ["/faq", "FAQ"],
];

function aggregateRatingFor(items) {
  if (!items.length) return null;
  const ratings = items.map((item) => {
    const value = Number(item.rating);
    return Number.isFinite(value) ? value : 5;
  });
  const average = ratings.reduce((sum, value) => sum + value, 0) / ratings.length;
  return {
    "@type": "AggregateRating",
    ratingValue: Math.round(average * 10) / 10,
    reviewCount: ratings.length,
    bestRating: 5,
    worstRating: 1,
  };
}

function breadcrumbList(origin, path, pageUrl) {
  const match = PAGE_CRUMBS.find(([prefix]) => path.startsWith(prefix));
  if (!match) return null;
  const homeUrl = origin ? `${origin}/` : "/";
  const pageItem = origin ? `${origin}${match[0]}` : match[0];
  return {
    "@type": "BreadcrumbList",
    "@id": `${pageUrl}#breadcrumb`,
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: homeUrl },
      { "@type": "ListItem", position: 2, name: match[1], item: pageItem },
    ],
  };
}

export function salonJsonLd({
  origin = "",
  path = "/",
  menu = [],
  faqs = [],
  reviews = [],
  images = [],
  hours = null,
} = {}) {
  const home = origin || "";
  const pageUrl = origin ? `${origin}${path}` : path;
  const logo = origin ? `${origin}${SITE_LOGO}` : SITE_LOGO;
  const salonId = `${home}/#salon`;
  const websiteId = `${home}/#website`;

  const salon = {
    "@type": ["NailSalon", "BeautySalon", "LocalBusiness"],
    "@id": salonId,
    name: SITE_NAME,
    alternateName: [
      "Starstruck Nails & Spa",
      "Starstruck Nails and Spa",
      "Starstruck Nails",
      "Starstruck Nail Spa",
    ],
    description: SEO_DESCRIPTION,
    url: home || undefined,
    image: [logo],
    logo: {
      "@type": "ImageObject",
      url: logo,
      width: 1024,
      height: 1024,
    },
    telephone: "+1-520-250-4136",
    email: SITE_EMAIL,
    priceRange: "$$",
    currenciesAccepted: "USD",
    paymentAccepted: "Cash, Credit Card",
    address: {
      "@type": "PostalAddress",
      streetAddress: SITE_STREET,
      addressLocality: SITE_CITY,
      addressRegion: SITE_REGION,
      postalCode: SITE_POSTAL,
      addressCountry: "US",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 32.3234,
      longitude: -111.0106,
    },
    hasMap: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(SITE_ADDRESS)}`,
    areaServed: [
      { "@type": "City", name: "Tucson" },
      { "@type": "AdministrativeArea", name: "Pima County" },
      { "@type": "Place", name: "Northwest Tucson" },
      { "@type": "Place", name: "Oro Valley" },
    ],
    openingHours: hours
      ? hours.openingHours || []
      : ["Mo-Fr 09:00-19:00", "Sa 09:00-18:00"],
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+1-520-250-4136",
      email: SITE_EMAIL,
      contactType: "reservations",
      areaServed: "US",
      availableLanguage: "English",
    },
    potentialAction: {
      "@type": "ReserveAction",
      name: "Reserve a visit",
      target: home ? `${home}/reserve` : "/reserve",
    },
    openingHoursSpecification: hours
      ? hours.openingHoursSpecification || []
      : [
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            opens: "09:00",
            closes: "19:00",
          },
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: "Saturday",
            opens: "09:00",
            closes: "18:00",
          },
        ],
    knowsAbout: [
      "gel manicure",
      "spa pedicure",
      "manicure and pedicure combos",
      "acrylic nails",
      "acrylic nail refills",
      "nail art designs",
      "nail extensions",
      "builder gel",
      "Gel X",
      "dip powder",
      "waxing",
      "kids nails",
      "kids nail salon",
      "bridal parties",
      "party events",
      "work events",
    ],
    review: (path === "/" ? reviews || [] : []).map((item) => ({
      "@type": "Review",
      author: { "@type": "Person", name: item.name },
      reviewBody: item.quote,
      reviewRating: {
        "@type": "Rating",
        ratingValue: String(item.rating || 5),
        bestRating: "5",
        worstRating: "1",
      },
    })),
    makesOffer: (menu || []).flatMap((group) =>
      (group.items || [])
        .filter((item) => item.kind !== "note" && item.name)
        .map((item) => ({
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: item.name,
            description: item.aka || group.heading,
            areaServed: SITE_CITY,
          },
          price: item.price
            ? String(item.price).replace(/[^0-9.]/g, "")
            : undefined,
          priceCurrency: item.price ? "USD" : undefined,
        })),
    ),
  };

  const pageSeo = pageSeoForPath(path);
  const primarySrc = path.startsWith("/gallery")
    ? images?.[0]?.src || PAGE_SEO.gallery.image
    : "/industries/starstruck-hero.jpg";
  const primaryUrl = origin ? `${origin}${primarySrc}` : primarySrc;
  const crumbs = breadcrumbList(origin, path, pageUrl);
  const webpage = {
    "@type": "WebPage",
    "@id": `${pageUrl}#webpage`,
    url: pageUrl,
    name: pageSeo.title,
    description: pageSeo.description,
    isPartOf: { "@id": websiteId },
    about: { "@id": salonId },
    inLanguage: "en-US",
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: primaryUrl,
    },
  };
  if (crumbs) webpage.breadcrumb = { "@id": crumbs["@id"] };
  if (path.startsWith("/contact")) webpage["@type"] = ["ContactPage", "WebPage"];
  if (path.startsWith("/gallery") && images?.length) {
    webpage.mainEntity = { "@id": `${pageUrl}#gallery` };
  }

  const graph = [
    salon,
    {
      "@type": "WebSite",
      "@id": websiteId,
      url: home || undefined,
      name: SITE_NAME,
      description: SEO_DESCRIPTION,
      inLanguage: "en-US",
      publisher: { "@id": salonId },
    },
    webpage,
  ];

  if (crumbs) graph.push(crumbs);

  if (!salon.review.length) {
    delete salon.review;
  } else {
    salon.aggregateRating = aggregateRatingFor(path === "/" ? reviews || [] : []);
  }
  if (!salon.makesOffer.length) {
    delete salon.makesOffer;
  }

  if (path.startsWith("/faq") && faqs?.length) {
    graph.push({
      "@type": "FAQPage",
      "@id": `${pageUrl}#faq`,
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.a,
        },
      })),
    });
  }

  if (path.startsWith("/gallery") && images?.length) {
    graph.push({
      "@type": "ImageGallery",
      "@id": `${pageUrl}#gallery`,
      name: PAGE_SEO.gallery.title,
      description: PAGE_SEO.gallery.description,
      url: pageUrl,
      about: { "@id": salonId },
      mainEntityOfPage: { "@id": `${pageUrl}#webpage` },
      image: images.map((photo) => ({
        "@type": "ImageObject",
        contentUrl: origin ? `${origin}${photo.src}` : photo.src,
        caption: photo.alt,
        name: photo.caption,
      })),
    });
  }

  return {
    "@context": "https://schema.org",
    "@graph": graph,
  };
}
